// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__Jc5tO","link":"Breadcrumbs_link__G4uRP","separator":"Breadcrumbs_separator__vUqYb","current":"Breadcrumbs_current__M1sCQ"};